import mfUiTheme from '@branditdev/mf_ui_theme'
import { extendTheme } from '@chakra-ui/react'

const addImportantToTheme = theme => {
  const updatedTheme = { ...theme }

  const processStyles = styles => {
    if (typeof styles !== 'object') return styles
    return Object.fromEntries(
      Object.entries(styles).map(([key, value]) => [
        key,
        typeof value === 'string' && !value.includes('!important') ? `${value} !important` : processStyles(value)
      ])
    )
  }

  updatedTheme.styles = processStyles(theme.styles)
  updatedTheme.components = Object.fromEntries(
    Object.entries(theme.components || {}).map(([key, config]) => [
      key,
      {
        ...config,
        baseStyle: processStyles(config.baseStyle || {}),
        variants: processStyles(config.variants || {}),
        sizes: processStyles(config.sizes || {})
      }
    ])
  )

  return updatedTheme
}

export const mfAdminChakraTheme = extendTheme(addImportantToTheme(mfUiTheme))
